<template>
    <v-row>
        <v-col sm="12" lg="6">
            <v-btn variant="text" @click="restore" style="width: 100%">
                RESTORE
                <v-icon right class="ml-2"> mdi-refresh </v-icon>
            </v-btn>
        </v-col>
        <v-col sm="12" lg="6">
            <v-btn variant="text" @click="share" style="width: 100%">
                SHARE
                <v-icon right class="ml-2"> mdi-share-variant-outline </v-icon>
            </v-btn>
        </v-col>
        <v-col sm="12" lg="6">
            <v-btn variant="text" @click="genhtml" style="width: 100%">
                HTML
                <v-icon right class="ml-2">mdi-tray-arrow-down</v-icon>
            </v-btn>
        </v-col>
        <v-col sm="12" lg="6">
            <PdfButton :record="record" :text="true" :maxWidth="true" />
        </v-col>
    </v-row>
</template>
<script setup>
import { useStore } from 'vuex'
import PdfButton from '../shared/PdfButton.vue'

const store = useStore()
const props = defineProps({
    record: {
        type: Object,
        required: true,
    },
})
const emit = defineEmits(['restore', 'share'])

async function genhtml() {
    props.record.showProgress = true
    store.dispatch('printHtml', props.record)
    props.record.showProgress = false
}

function restore() {
    emit('restore')
}

function share() {
    emit('share')
}
</script>
<style scoped>
.v-btn {
    font-weight: 500;
}
</style>
